import { createStyle } from "@gluestack-style/react";

export const Select = createStyle({
  backgroundColor: "$white",
  color: "$textLight800"
});
